var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"type":"is-primary","size":"is-small","outlined":"","disabled":_vm.retrying,"loading":_vm.retrying},on:{"click":_vm.retry}},[_vm._v("Retry")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }